// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3O28H","rootSuccess":"CompleteLink_rootSuccess__zQzW3","rootFailure":"CompleteLink_rootFailure__M_GIw","isDisabled":"CompleteLink_isDisabled__p1fwu"};